// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token_tokenMainContainer__Idw1B {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Arial", sans-serif;
}

.token_tokenHeader__TSp6v {
  text-align: center;
  margin-bottom: 30px;
  padding: 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
.token_tokenHeader__TSp6v h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  font-weight: 700;
}
.token_tokenHeader__TSp6v p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.token_tabNavigation__IfgVk {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  gap: 10px;
  flex-wrap: wrap;
}

.token_tabButton__uTEzQ {
  padding: 15px 25px;
  border: none;
  background: #f8f9fa;
  color: #495057;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.token_tabButton__uTEzQ:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.token_tabButton__uTEzQ.token_activeTab__n5LLP {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
}

.token_tabContent__n1ACj {
  min-height: 500px;
}

.token_tokenSearchContainer__xZO0n {
  max-width: 800px;
  margin: 0 auto;
}

.token_searchHeader__nerS\\+ {
  text-align: center;
  margin-bottom: 30px;
}
.token_searchHeader__nerS\\+ h2 {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 10px;
}
.token_searchHeader__nerS\\+ p {
  font-size: 1.1rem;
  color: #7f8c8d;
}

.token_searchForm__mYP7v {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.token_inputGroup__LaTic {
  margin-bottom: 25px;
}
.token_inputGroup__LaTic label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}
.token_inputGroup__LaTic input {
  width: 100%;
  padding: 15px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1.1rem;
  transition: border-color 0.3s ease;
}
.token_inputGroup__LaTic input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.token_inputGroup__LaTic small {
  display: block;
  margin-top: 5px;
  color: #6c757d;
  font-size: 0.9rem;
}

.token_searchButton__IYqkn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.token_searchButton__IYqkn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
}
.token_searchButton__IYqkn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.token_errorMessage__6yjnh {
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
}

.token_searchResult__gWHkc {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.token_resultHeader__NpmoD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  flex-wrap: wrap;
  gap: 15px;
}
.token_resultHeader__NpmoD h3 {
  color: #27ae60;
  font-size: 1.5rem;
  margin: 0;
}

.token_accessInfo__gNyA0 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
}

.token_accessBadge__rrFTW {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
}
.token_accessBadge__rrFTW.token_view__SbBKn {
  background: #e3f2fd;
  color: #1976d2;
}
.token_accessBadge__rrFTW.token_edit__4ggt6 {
  background: #fff3e0;
  color: #f57c00;
}
.token_accessBadge__rrFTW.token_admin__2FeVQ {
  background: #f3e5f5;
  color: #7b1fa2;
}

.token_expiryInfo__baGV4 {
  font-size: 0.9rem;
  color: #6c757d;
}

.token_dataPreview__A90CT {
  margin-bottom: 25px;
}
.token_dataPreview__A90CT h4 {
  color: #2c3e50;
  margin-bottom: 15px;
}

.token_infoGrid__5VPt2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.token_infoItem__hwCXY {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
  border-left: 4px solid #667eea;
}
.token_infoItem__hwCXY strong {
  color: #2c3e50;
}

.token_currentYearNotice__taC3c {
  grid-column: 1/-1;
  border-left-color: #1e8449;
  background: #eafaf1;
}

.token_actionButtons__ppj38 {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.token_actionButton__C5PL5 {
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 200px;
}
.token_actionButton__C5PL5.token_viewButton__NpssZ {
  background: #3498db;
  color: white;
}
.token_actionButton__C5PL5.token_viewButton__NpssZ:hover {
  background: #2980b9;
  transform: translateY(-2px);
}
.token_actionButton__C5PL5.token_editButton__dNWJE {
  background: #e67e22;
  color: white;
}
.token_actionButton__C5PL5.token_editButton__dNWJE:hover {
  background: #d35400;
  transform: translateY(-2px);
}

.token_helpSection__K-E9S {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 15px;
  margin-top: 30px;
}
.token_helpSection__K-E9S h4 {
  color: #2c3e50;
  margin-bottom: 15px;
}
.token_helpSection__K-E9S ul {
  list-style: none;
  padding: 0;
}
.token_helpSection__K-E9S ul li {
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
  color: #495057;
}
.token_helpSection__K-E9S ul li:last-child {
  border-bottom: none;
}

.token_tokenManagementContainer__4-nx4 {
  max-width: 1000px;
  margin: 0 auto;
}

.token_managementHeader__J0twp {
  text-align: center;
  margin-bottom: 30px;
  padding: 25px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px;
}
.token_managementHeader__J0twp h2 {
  font-size: 2rem;
  margin-bottom: 10px;
}
.token_managementHeader__J0twp p {
  font-size: 1.1rem;
  opacity: 0.9;
  margin-bottom: 20px;
}

.token_createButton__Rm3bh {
  padding: 15px 30px;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.token_createButton__Rm3bh:hover {
  background: #229954;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(39, 174, 96, 0.4);
}

.token_createForm__\\+J3Zz {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.token_createForm__\\+J3Zz h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.token_formRow__zdt5V {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.token_formGroup__pHPZ9 label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}
.token_formGroup__pHPZ9 input, .token_formGroup__pHPZ9 select, .token_formGroup__pHPZ9 textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}
.token_formGroup__pHPZ9 input:focus, .token_formGroup__pHPZ9 select:focus, .token_formGroup__pHPZ9 textarea:focus {
  outline: none;
  border-color: #667eea;
}
.token_formGroup__pHPZ9 textarea {
  min-height: 80px;
  resize: vertical;
}

.token_formActions__4meBf {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 25px;
}

.token_submitButton__F-vfX {
  padding: 12px 24px;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.token_submitButton__F-vfX:hover {
  background: #229954;
}

.token_cancelButton__zC\\+OM {
  padding: 12px 24px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.token_cancelButton__zC\\+OM:hover {
  background: #5a6268;
}

.token_tokenAccessList__vgOCg {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.token_tokenAccessList__vgOCg h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.token_tableContainer__tyFlx {
  overflow-x: auto;
}

.token_tokenTable__jGS9i {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.token_tokenTable__jGS9i th, .token_tokenTable__jGS9i td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.token_tokenTable__jGS9i th {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}
.token_tokenTable__jGS9i tr:hover {
  background: #f8f9fa;
}
.token_tokenTable__jGS9i tr.token_expired__8Aqxl {
  background: #fff5f5;
  opacity: 0.7;
}

.token_tokenCell__39-w- {
  font-family: "Courier New", monospace;
  font-weight: 600;
}

.token_statusBadge__7m7mK {
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
}
.token_statusBadge__7m7mK.token_active__3iSY1 {
  background: #d4edda;
  color: #155724;
}
.token_statusBadge__7m7mK.token_inactive__fSTOA {
  background: #f8d7da;
  color: #721c24;
}

.token_actionCells__J8giR {
  display: flex;
  gap: 8px;
}

.token_editButton__dNWJE, .token_deleteButton__jwB5t {
  padding: 6px 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
}
.token_editButton__dNWJE:hover, .token_deleteButton__jwB5t:hover {
  transform: scale(1.1);
}

.token_editButton__dNWJE {
  background: #ffc107;
  color: #212529;
}
.token_editButton__dNWJE:hover {
  background: #e0a800;
}

.token_deleteButton__jwB5t {
  background: #dc3545;
  color: white;
}
.token_deleteButton__jwB5t:hover {
  background: #c82333;
}

.token_editModal__wfn\\+p {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.token_modalContent__yklVQ {
  background: white;
  padding: 30px;
  border-radius: 15px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}
.token_modalContent__yklVQ h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.token_analyticsContainer__cx6PL {
  max-width: 1000px;
  margin: 0 auto;
}

.token_analyticsHeader__Hom7F {
  text-align: center;
  margin-bottom: 30px;
  padding: 25px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px;
}
.token_analyticsHeader__Hom7F h2 {
  font-size: 2rem;
  margin-bottom: 10px;
}
.token_analyticsHeader__Hom7F p {
  font-size: 1.1rem;
  opacity: 0.9;
}

.token_statsGrid__wrDwG {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.token_statCard__5z7bB {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;
}
.token_statCard__5z7bB:hover {
  transform: translateY(-5px);
}

.token_statIcon__Vd0tP {
  font-size: 3rem;
  margin-bottom: 15px;
}

.token_statContent__iGQgE h3 {
  color: #6c757d;
  font-size: 1rem;
  margin-bottom: 10px;
}

.token_statNumber__q5DgY {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
}

.token_chartSection__a4Eq\\+ {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.token_chartSection__a4Eq\\+ h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.token_progressBar__LtUin {
  width: 100%;
  height: 20px;
  background: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

.token_progressFill__qiywN {
  height: 100%;
  background: linear-gradient(90deg, #27ae60, #2ecc71);
  transition: width 0.5s ease;
}

.token_chartLabels__19bpq {
  display: flex;
  justify-content: space-between;
  color: #6c757d;
  font-size: 0.9rem;
}

.token_recentSearches__BFkuu {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.token_recentSearches__BFkuu h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.token_analyticsTable__6T5hj {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.token_analyticsTable__6T5hj th, .token_analyticsTable__6T5hj td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.token_analyticsTable__6T5hj th {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}
.token_analyticsTable__6T5hj tr:hover {
  background: #f8f9fa;
}
.token_analyticsTable__6T5hj tr.token_found__w79rL {
  border-left: 4px solid #27ae60;
}
.token_analyticsTable__6T5hj tr.token_not_found__CYT9p {
  border-left: 4px solid #e74c3c;
}
.token_analyticsTable__6T5hj tr.token_expired__8Aqxl {
  border-left: 4px solid #f39c12;
}
.token_analyticsTable__6T5hj tr.token_no_access__U4Xo8 {
  border-left: 4px solid #9b59b6;
}

.token_resultBadge__2DrJc {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}
.token_resultBadge__2DrJc.token_found__w79rL {
  background: #d4edda;
  color: #155724;
}
.token_resultBadge__2DrJc.token_not_found__CYT9p {
  background: #f8d7da;
  color: #721c24;
}
.token_resultBadge__2DrJc.token_expired__8Aqxl {
  background: #fff3cd;
  color: #856404;
}
.token_resultBadge__2DrJc.token_no_access__U4Xo8 {
  background: #e2d9f3;
  color: #6f42c1;
}

.token_insightsSection__0lojb {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.token_insightsSection__0lojb h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.token_insightsGrid__WQkt- {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.token_insightCard__QfPV7 {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  border-left: 4px solid #667eea;
}
.token_insightCard__QfPV7 h4 {
  color: #2c3e50;
  margin-bottom: 10px;
}
.token_insightCard__QfPV7 p {
  color: #495057;
  margin: 0;
}

.token_exportSection__sYxgI {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.token_exportSection__sYxgI h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.token_exportButtons__N8e5J {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.token_exportButton__Hrn7G {
  padding: 12px 24px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.token_exportButton__Hrn7G:hover {
  background: #5a6268;
  transform: translateY(-2px);
}

.token_infoSection__IAMjq {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  margin: 40px 0;
}

.token_infoCard__sxJIp {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.token_infoCard__sxJIp h3 {
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 1.3rem;
}
.token_infoCard__sxJIp ol, .token_infoCard__sxJIp ul {
  padding-left: 20px;
  color: #495057;
  line-height: 1.6;
}
.token_infoCard__sxJIp ol li, .token_infoCard__sxJIp ul li {
  margin-bottom: 10px;
}

.token_usageSteps__CB8Ca .token_step__07dx2 {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}
.token_usageSteps__CB8Ca .token_step__07dx2 .token_stepNumber__pUcE2 {
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
}
.token_usageSteps__CB8Ca .token_step__07dx2 p {
  margin: 0;
  color: #495057;
}

.token_tokenFooter__zQ\\+B2 {
  text-align: center;
  padding: 30px;
  background: #f8f9fa;
  border-radius: 15px;
  margin-top: 40px;
}
.token_tokenFooter__zQ\\+B2 p {
  color: #6c757d;
  margin: 5px 0;
}

.token_loading__R8Tb4 {
  text-align: center;
  padding: 50px;
  font-size: 1.2rem;
  color: #6c757d;
}

.token_noData__t74KF {
  text-align: center;
  padding: 50px;
  color: #6c757d;
  font-style: italic;
}

@media (max-width: 768px) {
  .token_tokenMainContainer__Idw1B {
    padding: 15px;
  }
  .token_tokenHeader__TSp6v h1 {
    font-size: 2rem;
  }
  .token_tabNavigation__IfgVk {
    flex-direction: column;
    align-items: center;
  }
  .token_tabButton__uTEzQ {
    width: 100%;
    max-width: 300px;
  }
  .token_formRow__zdt5V {
    grid-template-columns: 1fr;
  }
  .token_actionButtons__ppj38 {
    flex-direction: column;
  }
  .token_actionButton__C5PL5 {
    min-width: auto;
  }
  .token_statsGrid__wrDwG {
    grid-template-columns: 1fr;
  }
  .token_insightsGrid__WQkt- {
    grid-template-columns: 1fr;
  }
  .token_exportButtons__N8e5J {
    flex-direction: column;
  }
  .token_infoSection__IAMjq {
    grid-template-columns: 1fr;
  }
}
.token_modalOverlay__RzF7W {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.token_modalContent__yklVQ {
  background: white;
  border-radius: 15px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: token_modalSlideIn__CujcO 0.3s ease-out;
}

@keyframes token_modalSlideIn__CujcO {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.token_modalHeader__b3xTv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 2px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px 15px 0 0;
}
.token_modalHeader__b3xTv h3 {
  margin: 0;
  font-size: 1.5rem;
}

.token_closeButton__ufaXm {
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.token_closeButton__ufaXm:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.token_modalBody__ahVHr {
  padding: 30px;
}
.token_modalBody__ahVHr .token_dataInfo__RlXZP, .token_modalBody__ahVHr .token_accessInfo__gNyA0 {
  margin-bottom: 25px;
}
.token_modalBody__ahVHr .token_dataInfo__RlXZP h4, .token_modalBody__ahVHr .token_accessInfo__gNyA0 h4 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 1.2rem;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}
.token_modalBody__ahVHr .token_infoGrid__5VPt2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}
.token_modalBody__ahVHr .token_infoItem__hwCXY {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #007bff;
}
.token_modalBody__ahVHr .token_infoItem__hwCXY strong {
  color: #2c3e50;
  display: block;
  margin-bottom: 5px;
}
.token_modalBody__ahVHr .token_accessDetails__NcltG {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}
.token_modalBody__ahVHr .token_editNote__YlCvj, .token_modalBody__ahVHr .token_viewNote__YqSLH {
  background: #e8f5e8;
  border: 1px solid #28a745;
  border-radius: 8px;
  padding: 15px;
  margin-top: 20px;
}
.token_modalBody__ahVHr .token_editNote__YlCvj p, .token_modalBody__ahVHr .token_viewNote__YqSLH p {
  margin: 0;
  color: #155724;
  font-weight: 500;
}
.token_modalBody__ahVHr .token_viewNote__YqSLH {
  background: #fff3cd;
  border-color: #ffc107;
}
.token_modalBody__ahVHr .token_viewNote__YqSLH p {
  color: #856404;
}

.token_modalFooter__1rSqO {
  padding: 20px 30px;
  border-top: 2px solid #e9ecef;
  text-align: center;
  background: #f8f9fa;
  border-radius: 0 0 15px 15px;
}

.token_closeModalButton__HCNl3 {
  padding: 12px 30px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.token_closeModalButton__HCNl3:hover {
  background: #5a6268;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .token_modalContent__yklVQ {
    margin: 10px;
    max-height: 95vh;
  }
  .token_modalHeader__b3xTv {
    padding: 20px;
  }
  .token_modalHeader__b3xTv h3 {
    font-size: 1.3rem;
  }
  .token_modalBody__ahVHr {
    padding: 20px;
  }
  .token_infoGrid__5VPt2 {
    grid-template-columns: 1fr;
  }
  .token_accessDetails__NcltG {
    flex-direction: column;
    align-items: flex-start;
  }
}
.token_tokenSearchPageContainer__cehDj {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  font-family: "Arial", sans-serif;
}

.token_pageHeader__YOejx {
  text-align: center;
  margin-bottom: 40px;
  padding: 40px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  position: relative;
}
.token_pageHeader__YOejx h1 {
  font-size: 3rem;
  margin: 20px 0 15px 0;
  font-weight: 700;
}
.token_pageHeader__YOejx p {
  font-size: 1.3rem;
  opacity: 0.9;
  margin: 0;
}

.token_backButton__rL27o {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}
.token_backButton__rL27o:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}
.token_backButton__rL27o:active {
  transform: translateY(0);
}

.token_tokenInput__FxqMt {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.token_budgetPopupOverlay__Ghq6p {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1200;
}

.token_budgetPopupContainer__U1cNb {
  width: min(1180px, 100%);
  max-height: calc(100vh - 40px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.28);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.token_budgetPopupHeader__eY0rd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
}
.token_budgetPopupHeader__eY0rd h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
}

.token_budgetPopupClose__loz9t {
  border: none;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  font-size: 1.3rem;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
}
.token_budgetPopupClose__loz9t:hover {
  background: rgba(255, 255, 255, 0.3);
}

.token_budgetPopupMeta__bi7Sy {
  padding: 14px 22px;
  background: #f8f9fb;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  font-size: 0.95rem;
  color: #2c3e50;
}

.token_budgetPopupLoading__JENJB {
  padding: 28px 22px;
  text-align: center;
  color: #495057;
  font-weight: 600;
}

.token_budgetPopupTableWrapper__QRH3k {
  overflow: auto;
  padding: 0 22px 12px;
}

.token_budgetPopupTable__mp64l {
  width: 100%;
  border-collapse: collapse;
  min-width: 780px;
}
.token_budgetPopupTable__mp64l th, .token_budgetPopupTable__mp64l td {
  border-bottom: 1px solid #edf1f5;
  padding: 10px 8px;
  text-align: left;
  vertical-align: middle;
}
.token_budgetPopupTable__mp64l th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f3f6fb;
  color: #334155;
  font-size: 0.92rem;
  font-weight: 700;
}
.token_budgetPopupTable__mp64l td {
  background: #ffffff;
}
.token_budgetPopupTable__mp64l input {
  width: 100%;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  padding: 9px 10px;
  font-size: 0.95rem;
  color: #1f2937;
  background: #ffffff;
}
.token_budgetPopupTable__mp64l input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);
}
.token_budgetPopupTable__mp64l input[readonly] {
  background: #f5f7fb;
  color: #5b6472;
}

.token_budgetPopupCategoryRow__\\+nXPc td {
  background: #f3f6fb !important;
  color: #1f2937;
  font-weight: 700;
  border-top: 1px solid #d8e2f0;
  border-bottom: 1px solid #d8e2f0;
}

.token_budgetPopupTotalRow__0mooG td {
  background: #faf7ef !important;
  font-weight: 700;
  color: #5b4016;
}

.token_budgetPopupGrandTotalRow__oPVF\\+ td {
  background: #e7f6ec !important;
  font-weight: 700;
  color: #14532d;
  border-top: 1px solid #cfe9d8;
}

.token_budgetPopupMessage__YCC\\+Q {
  margin: 10px 22px 0;
  padding: 11px 14px;
  border-radius: 10px;
  font-size: 0.92rem;
  font-weight: 600;
}
.token_budgetPopupMessage__YCC\\+Q.token_success__xcb0L {
  background: #eafaf1;
  color: #166534;
  border: 1px solid #ccefdc;
}
.token_budgetPopupMessage__YCC\\+Q.token_error__XrA6r {
  background: #fff1f2;
  color: #9f1239;
  border: 1px solid #ffd6de;
}

.token_budgetPopupActions__K8b2p {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px 18px;
  border-top: 1px solid #e9ecef;
  background: #ffffff;
}

.token_budgetPopupCancelButton__etVhI,
.token_budgetPopupSaveButton__V\\+HWv {
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 0.94rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.token_budgetPopupCancelButton__etVhI {
  background: #e9ecef;
  color: #334155;
}
.token_budgetPopupCancelButton__etVhI:hover {
  background: #dfe3e8;
}

.token_budgetPopupSaveButton__V\\+HWv {
  background: #e67e22;
  color: #ffffff;
}
.token_budgetPopupSaveButton__V\\+HWv:hover:not(:disabled) {
  background: #d96f0f;
}
.token_budgetPopupSaveButton__V\\+HWv:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .token_budgetPopupOverlay__Ghq6p {
    padding: 10px;
  }
  .token_budgetPopupContainer__U1cNb {
    max-height: calc(100vh - 20px);
    border-radius: 12px;
  }
  .token_budgetPopupHeader__eY0rd {
    padding: 14px 16px;
  }
  .token_budgetPopupHeader__eY0rd h3 {
    font-size: 1rem;
  }
  .token_budgetPopupMeta__bi7Sy {
    padding: 12px 16px;
    font-size: 0.88rem;
  }
  .token_budgetPopupTableWrapper__QRH3k {
    padding: 0 10px 8px;
  }
  .token_budgetPopupTable__mp64l {
    min-width: 660px;
  }
  .token_budgetPopupActions__K8b2p {
    padding: 12px 16px 14px;
    flex-direction: column-reverse;
  }
  .token_budgetPopupCancelButton__etVhI,
  .token_budgetPopupSaveButton__V\\+HWv {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/token/token.module.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,gCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;AAAF;AAEE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,YAAA;AADJ;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;AAHF;AAKE;EACE,mBAAA;EACA,2BAAA;EACA,yCAAA;AAHJ;AAME;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;EACA,+CAAA;AAJJ;;AAQA;EACE,iBAAA;AALF;;AASA;EACE,gBAAA;EACA,cAAA;AANF;;AASA;EACE,kBAAA;EACA,mBAAA;AANF;AAQE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AANJ;AASE;EACE,iBAAA;EACA,cAAA;AAPJ;;AAWA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;AAUE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAWE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;AATJ;AAWI;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AATN;AAaE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAXJ;;AAeA;EACE,WAAA;EACA,aAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAZF;AAcE;EACE,2BAAA;EACA,gDAAA;AAZJ;AAeE;EACE,YAAA;EACA,mBAAA;AAbJ;;AAiBA;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAdF;AAgBE;EACE,cAAA;EACA,iBAAA;EACA,SAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAfF;AAiBE;EACE,mBAAA;EACA,cAAA;AAfJ;AAkBE;EACE,mBAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,mBAAA;EACA,cAAA;AAjBJ;;AAqBA;EACE,iBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;AAoBE;EACE,cAAA;EACA,mBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAnBF;AAqBE;EACE,cAAA;AAnBJ;;AAuBA;EACE,iBAAA;EACA,0BAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AApBF;AAsBE;EACE,mBAAA;EACA,YAAA;AApBJ;AAsBI;EACE,mBAAA;EACA,2BAAA;AApBN;AAwBE;EACE,mBAAA;EACA,YAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,2BAAA;AAtBN;;AA2BA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAxBF;AA0BE;EACE,cAAA;EACA,mBAAA;AAxBJ;AA2BE;EACE,gBAAA;EACA,UAAA;AAzBJ;AA2BI;EACE,cAAA;EACA,gCAAA;EACA,cAAA;AAzBN;AA2BM;EACE,mBAAA;AAzBR;;AAgCA;EACE,iBAAA;EACA,cAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,6DAAA;EACA,YAAA;EACA,mBAAA;AA7BF;AA+BE;EACE,eAAA;EACA,mBAAA;AA7BJ;AAgCE;EACE,iBAAA;EACA,YAAA;EACA,mBAAA;AA9BJ;;AAkCA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA/BF;AAiCE;EACE,mBAAA;EACA,2BAAA;EACA,8CAAA;AA/BJ;;AAmCA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAhCF;AAkCE;EACE,cAAA;EACA,mBAAA;AAhCJ;;AAoCA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAjCF;;AAqCE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAlCJ;AAqCE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AAnCJ;AAqCI;EACE,aAAA;EACA,qBAAA;AAnCN;AAuCE;EACE,gBAAA;EACA,gBAAA;AArCJ;;AAyCA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AAtCF;;AAyCA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAtCF;AAwCE;EACE,mBAAA;AAtCJ;;AA0CA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAvCF;AAyCE;EACE,mBAAA;AAvCJ;;AA2CA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAxCF;AA0CE;EACE,cAAA;EACA,mBAAA;AAxCJ;;AA4CA;EACE,gBAAA;AAzCF;;AA4CA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAzCF;AA2CE;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;AAzCJ;AA4CE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AA1CJ;AA6CE;EACE,mBAAA;AA3CJ;AA8CE;EACE,mBAAA;EACA,YAAA;AA5CJ;;AAgDA;EACE,qCAAA;EACA,gBAAA;AA7CF;;AAgDA;EACE,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA7CF;AA+CE;EACE,mBAAA;EACA,cAAA;AA7CJ;AAgDE;EACE,mBAAA;EACA,cAAA;AA9CJ;;AAkDA;EACE,aAAA;EACA,QAAA;AA/CF;;AAkDA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AA/CF;AAiDE;EACE,qBAAA;AA/CJ;;AAmDA;EACE,mBAAA;EACA,cAAA;AAhDF;AAkDE;EACE,mBAAA;AAhDJ;;AAoDA;EACE,mBAAA;EACA,YAAA;AAjDF;AAmDE;EACE,mBAAA;AAjDJ;;AAqDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAlDF;;AAqDA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAlDF;AAoDE;EACE,cAAA;EACA,mBAAA;AAlDJ;;AAuDA;EACE,iBAAA;EACA,cAAA;AApDF;;AAuDA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,6DAAA;EACA,YAAA;EACA,mBAAA;AApDF;AAsDE;EACE,eAAA;EACA,mBAAA;AApDJ;AAuDE;EACE,iBAAA;EACA,YAAA;AArDJ;;AAyDA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAtDF;;AAyDA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,+BAAA;AAtDF;AAwDE;EACE,2BAAA;AAtDJ;;AA0DA;EACE,eAAA;EACA,mBAAA;AAvDF;;AA2DE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAxDJ;;AA4DA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAzDF;AA2DE;EACE,cAAA;EACA,mBAAA;AAzDJ;;AA6DA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA1DF;;AA6DA;EACE,YAAA;EACA,oDAAA;EACA,2BAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;AA1DF;;AA6DA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AA1DF;AA4DE;EACE,cAAA;EACA,mBAAA;AA1DJ;;AA8DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AA3DF;AA6DE;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;AA3DJ;AA8DE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AA5DJ;AA+DE;EACE,mBAAA;AA7DJ;AAgEE;EACE,8BAAA;AA9DJ;AAiEE;EACE,8BAAA;AA/DJ;AAkEE;EACE,8BAAA;AAhEJ;AAmEE;EACE,8BAAA;AAjEJ;;AAqEA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAlEF;AAoEE;EACE,mBAAA;EACA,cAAA;AAlEJ;AAqEE;EACE,mBAAA;EACA,cAAA;AAnEJ;AAsEE;EACE,mBAAA;EACA,cAAA;AApEJ;AAuEE;EACE,mBAAA;EACA,cAAA;AArEJ;;AAyEA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAtEF;AAwEE;EACE,cAAA;EACA,mBAAA;AAtEJ;;AA0EA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAvEF;;AA0EA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAvEF;AAyEE;EACE,cAAA;EACA,mBAAA;AAvEJ;AA0EE;EACE,cAAA;EACA,SAAA;AAxEJ;;AA4EA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAzEF;AA2EE;EACE,cAAA;EACA,mBAAA;AAzEJ;;AA6EA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA1EF;;AA6EA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA1EF;AA4EE;EACE,mBAAA;EACA,2BAAA;AA1EJ;;AA+EA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,cAAA;AA5EF;;AA+EA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AA5EF;AA8EE;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;AA5EJ;AA+EE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AA7EJ;AA+EI;EACE,mBAAA;AA7EN;;AAmFE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAhFJ;AAkFI;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAhFN;AAmFI;EACE,SAAA;EACA,cAAA;AAjFN;;AAuFA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AApFF;AAsFE;EACE,cAAA;EACA,aAAA;AApFJ;;AAyFA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAtFF;;AAyFA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAtFF;;AA0FA;EACE;IACE,aAAA;EAvFF;EA0FA;IACE,eAAA;EAxFF;EA2FA;IACE,sBAAA;IACA,mBAAA;EAzFF;EA4FA;IACE,WAAA;IACA,gBAAA;EA1FF;EA6FA;IACE,0BAAA;EA3FF;EA8FA;IACE,sBAAA;EA5FF;EA+FA;IACE,eAAA;EA7FF;EAgGA;IACE,0BAAA;EA9FF;EAiGA;IACE,0BAAA;EA/FF;EAkGA;IACE,sBAAA;EAhGF;EAmGA;IACE,0BAAA;EAjGF;AACF;AAqGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAnGF;;AAsGA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,kDAAA;AAnGF;;AAsGA;EACE;IACE,UAAA;IACA,uCAAA;EAnGF;EAqGA;IACE,UAAA;IACA,iCAAA;EAnGF;AACF;AAsGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,6DAAA;EACA,YAAA;EACA,4BAAA;AApGF;AAsGE;EACE,SAAA;EACA,iBAAA;AApGJ;;AAwGA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AArGF;AAuGE;EACE,oCAAA;EACA,qBAAA;AArGJ;;AAyGA;EACE,aAAA;AAtGF;AAwGE;EACE,mBAAA;AAtGJ;AAwGI;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAtGN;AA0GE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAxGJ;AA2GE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AAzGJ;AA2GI;EACE,cAAA;EACA,cAAA;EACA,kBAAA;AAzGN;AA6GE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA3GJ;AA8GE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA5GJ;AA8GI;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AA5GN;AAgHE;EACE,mBAAA;EACA,qBAAA;AA9GJ;AAgHI;EACE,cAAA;AA9GN;;AAmHA;EACE,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;AAhHF;;AAmHA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAhHF;AAkHE;EACE,mBAAA;EACA,2BAAA;AAhHJ;;AAqHA;EACE;IACE,YAAA;IACA,gBAAA;EAlHF;EAqHA;IACE,aAAA;EAnHF;EAqHE;IACE,iBAAA;EAnHJ;EAuHA;IACE,aAAA;EArHF;EAwHA;IACE,0BAAA;EAtHF;EAyHA;IACE,sBAAA;IACA,uBAAA;EAvHF;AACF;AA2HA;EACE,iBAAA;EACA,6DAAA;EACA,aAAA;EACA,gCAAA;AAzHF;;AA4HA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AAzHF;AA2HE;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;AAzHJ;AA4HE;EACE,iBAAA;EACA,YAAA;EACA,SAAA;AA1HJ;;AA8HA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;AA3HF;AA6HE;EACE,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;AA3HJ;AA8HE;EACE,wBAAA;AA5HJ;;AAgIA;EACE,yBAAA;EACA,qBAAA;AA7HF;;AAgIA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AA7HF;;AAgIA;EACE,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA7HF;;AAgIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,6DAAA;EACA,cAAA;AA7HF;AA+HE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AA7HJ;;AAiIA;EACE,YAAA;EACA,qCAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AA9HF;AAgIE;EACE,oCAAA;AA9HJ;;AAkIA;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AA/HF;;AAkIA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AA/HF;;AAkIA;EACE,cAAA;EACA,oBAAA;AA/HF;;AAkIA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AA/HF;AAiIE;EACE,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AA/HJ;AAkIE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAhIJ;AAmIE;EACE,mBAAA;AAjIJ;AAoIE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAlIJ;AAoII;EACE,aAAA;EACA,qBAAA;EACA,+CAAA;AAlIN;AAqII;EACE,mBAAA;EACA,cAAA;AAnIN;;AAwIA;EACE,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;EACA,gCAAA;AArIF;;AAwIA;EACE,8BAAA;EACA,gBAAA;EACA,cAAA;AArIF;;AAwIA;EACE,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;AArIF;;AAwIA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AArIF;AAuIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArIJ;AAwIE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAtIJ;;AA0IA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;AAvIF;;AA0IA;;EAEE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAvIF;;AA0IA;EACE,mBAAA;EACA,cAAA;AAvIF;AAyIE;EACE,mBAAA;AAvIJ;;AA2IA;EACE,mBAAA;EACA,cAAA;AAxIF;AA0IE;EACE,mBAAA;AAxIJ;AA2IE;EACE,YAAA;EACA,mBAAA;AAzIJ;;AA6IA;EACE;IACE,aAAA;EA1IF;EA6IA;IACE,8BAAA;IACA,mBAAA;EA3IF;EA8IA;IACE,kBAAA;EA5IF;EA8IE;IACE,eAAA;EA5IJ;EAgJA;IACE,kBAAA;IACA,kBAAA;EA9IF;EAiJA;IACE,mBAAA;EA/IF;EAkJA;IACE,gBAAA;EAhJF;EAmJA;IACE,uBAAA;IACA,8BAAA;EAjJF;EAoJA;;IAEE,WAAA;EAlJF;AACF","sourcesContent":["// Token Main Container\n.tokenMainContainer {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: 'Arial', sans-serif;\n}\n\n.tokenHeader {\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 30px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n\n  h1 {\n    font-size: 2.5rem;\n    margin-bottom: 10px;\n    font-weight: 700;\n  }\n\n  p {\n    font-size: 1.2rem;\n    opacity: 0.9;\n  }\n}\n\n// Tab Navigation\n.tabNavigation {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.tabButton {\n  padding: 15px 25px;\n  border: none;\n  background: #f8f9fa;\n  color: #495057;\n  border-radius: 25px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n\n  &:hover {\n    background: #e9ecef;\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  }\n\n  &.activeTab {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border-color: #667eea;\n    box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);\n  }\n}\n\n.tabContent {\n  min-height: 500px;\n}\n\n// Token Search Styles\n.tokenSearchContainer {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.searchHeader {\n  text-align: center;\n  margin-bottom: 30px;\n\n  h2 {\n    font-size: 2rem;\n    color: #2c3e50;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 1.1rem;\n    color: #7f8c8d;\n  }\n}\n\n.searchForm {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n}\n\n.inputGroup {\n  margin-bottom: 25px;\n\n  label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #2c3e50;\n  }\n\n  input {\n    width: 100%;\n    padding: 15px;\n    border: 2px solid #e9ecef;\n    border-radius: 10px;\n    font-size: 1.1rem;\n    transition: border-color 0.3s ease;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n    }\n  }\n\n  small {\n    display: block;\n    margin-top: 5px;\n    color: #6c757d;\n    font-size: 0.9rem;\n  }\n}\n\n.searchButton {\n  width: 100%;\n  padding: 15px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.errorMessage {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 15px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.searchResult {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n}\n\n.resultHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  flex-wrap: wrap;\n  gap: 15px;\n\n  h3 {\n    color: #27ae60;\n    font-size: 1.5rem;\n    margin: 0;\n  }\n}\n\n.accessInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-end;\n}\n\n.accessBadge {\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-align: center;\n\n  &.view {\n    background: #e3f2fd;\n    color: #1976d2;\n  }\n\n  &.edit {\n    background: #fff3e0;\n    color: #f57c00;\n  }\n\n  &.admin {\n    background: #f3e5f5;\n    color: #7b1fa2;\n  }\n}\n\n.expiryInfo {\n  font-size: 0.9rem;\n  color: #6c757d;\n}\n\n.dataPreview {\n  margin-bottom: 25px;\n\n  h4 {\n    color: #2c3e50;\n    margin-bottom: 15px;\n  }\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.infoItem {\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border-left: 4px solid #667eea;\n\n  strong {\n    color: #2c3e50;\n  }\n}\n\n.currentYearNotice {\n  grid-column: 1 / -1;\n  border-left-color: #1e8449;\n  background: #eafaf1;\n}\n\n.actionButtons {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.actionButton {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 200px;\n\n  &.viewButton {\n    background: #3498db;\n    color: white;\n\n    &:hover {\n      background: #2980b9;\n      transform: translateY(-2px);\n    }\n  }\n\n  &.editButton {\n    background: #e67e22;\n    color: white;\n\n    &:hover {\n      background: #d35400;\n      transform: translateY(-2px);\n    }\n  }\n}\n\n.helpSection {\n  background: #f8f9fa;\n  padding: 25px;\n  border-radius: 15px;\n  margin-top: 30px;\n\n  h4 {\n    color: #2c3e50;\n    margin-bottom: 15px;\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n\n    li {\n      padding: 8px 0;\n      border-bottom: 1px solid #e9ecef;\n      color: #495057;\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n  }\n}\n\n// Token Management Styles\n.tokenManagementContainer {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.managementHeader {\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 25px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 15px;\n\n  h2 {\n    font-size: 2rem;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 1.1rem;\n    opacity: 0.9;\n    margin-bottom: 20px;\n  }\n}\n\n.createButton {\n  padding: 15px 30px;\n  background: #27ae60;\n  color: white;\n  border: none;\n  border-radius: 25px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: #229954;\n    transform: translateY(-2px);\n    box-shadow: 0 10px 25px rgba(39, 174, 96, 0.4);\n  }\n}\n\n.createForm {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n  }\n}\n\n.formRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.formGroup {\n  label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #2c3e50;\n  }\n\n  input, select, textarea {\n    width: 100%;\n    padding: 12px;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    font-size: 1rem;\n    transition: border-color 0.3s ease;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n    }\n  }\n\n  textarea {\n    min-height: 80px;\n    resize: vertical;\n  }\n}\n\n.formActions {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-end;\n  margin-top: 25px;\n}\n\n.submitButton {\n  padding: 12px 24px;\n  background: #27ae60;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: #229954;\n  }\n}\n\n.cancelButton {\n  padding: 12px 24px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: #5a6268;\n  }\n}\n\n.tokenAccessList {\n  background: white;\n  padding: 25px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n  }\n}\n\n.tableContainer {\n  overflow-x: auto;\n}\n\n.tokenTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n\n  th, td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #e9ecef;\n  }\n\n  th {\n    background: #f8f9fa;\n    font-weight: 600;\n    color: #2c3e50;\n  }\n\n  tr:hover {\n    background: #f8f9fa;\n  }\n\n  tr.expired {\n    background: #fff5f5;\n    opacity: 0.7;\n  }\n}\n\n.tokenCell {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n}\n\n.statusBadge {\n  padding: 6px 12px;\n  border-radius: 15px;\n  font-size: 0.8rem;\n  font-weight: 600;\n\n  &.active {\n    background: #d4edda;\n    color: #155724;\n  }\n\n  &.inactive {\n    background: #f8d7da;\n    color: #721c24;\n  }\n}\n\n.actionCells {\n  display: flex;\n  gap: 8px;\n}\n\n.editButton, .deleteButton {\n  padding: 6px 10px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n\n.editButton {\n  background: #ffc107;\n  color: #212529;\n\n  &:hover {\n    background: #e0a800;\n  }\n}\n\n.deleteButton {\n  background: #dc3545;\n  color: white;\n\n  &:hover {\n    background: #c82333;\n  }\n}\n\n.editModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n  }\n}\n\n// Token Analytics Styles\n.analyticsContainer {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.analyticsHeader {\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 25px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 15px;\n\n  h2 {\n    font-size: 2rem;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 1.1rem;\n    opacity: 0.9;\n  }\n}\n\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.statCard {\n  background: white;\n  padding: 25px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  transition: transform 0.3s ease;\n\n  &:hover {\n    transform: translateY(-5px);\n  }\n}\n\n.statIcon {\n  font-size: 3rem;\n  margin-bottom: 15px;\n}\n\n.statContent {\n  h3 {\n    color: #6c757d;\n    font-size: 1rem;\n    margin-bottom: 10px;\n  }\n}\n\n.statNumber {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2c3e50;\n}\n\n.chartSection {\n  background: white;\n  padding: 25px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n  }\n}\n\n.progressBar {\n  width: 100%;\n  height: 20px;\n  background: #e9ecef;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.progressFill {\n  height: 100%;\n  background: linear-gradient(90deg, #27ae60, #2ecc71);\n  transition: width 0.5s ease;\n}\n\n.chartLabels {\n  display: flex;\n  justify-content: space-between;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.recentSearches {\n  background: white;\n  padding: 25px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n  }\n}\n\n.analyticsTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n\n  th, td {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #e9ecef;\n  }\n\n  th {\n    background: #f8f9fa;\n    font-weight: 600;\n    color: #2c3e50;\n  }\n\n  tr:hover {\n    background: #f8f9fa;\n  }\n\n  tr.found {\n    border-left: 4px solid #27ae60;\n  }\n\n  tr.not_found {\n    border-left: 4px solid #e74c3c;\n  }\n\n  tr.expired {\n    border-left: 4px solid #f39c12;\n  }\n\n  tr.no_access {\n    border-left: 4px solid #9b59b6;\n  }\n}\n\n.resultBadge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n\n  &.found {\n    background: #d4edda;\n    color: #155724;\n  }\n\n  &.not_found {\n    background: #f8d7da;\n    color: #721c24;\n  }\n\n  &.expired {\n    background: #fff3cd;\n    color: #856404;\n  }\n\n  &.no_access {\n    background: #e2d9f3;\n    color: #6f42c1;\n  }\n}\n\n.insightsSection {\n  background: white;\n  padding: 25px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n  }\n}\n\n.insightsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.insightCard {\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border-left: 4px solid #667eea;\n\n  h4 {\n    color: #2c3e50;\n    margin-bottom: 10px;\n  }\n\n  p {\n    color: #495057;\n    margin: 0;\n  }\n}\n\n.exportSection {\n  background: white;\n  padding: 25px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n  }\n}\n\n.exportButtons {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.exportButton {\n  padding: 12px 24px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: #5a6268;\n    transform: translateY(-2px);\n  }\n}\n\n// Information Section\n.infoSection {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 25px;\n  margin: 40px 0;\n}\n\n.infoCard {\n  background: white;\n  padding: 25px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n\n  h3 {\n    color: #2c3e50;\n    margin-bottom: 20px;\n    font-size: 1.3rem;\n  }\n\n  ol, ul {\n    padding-left: 20px;\n    color: #495057;\n    line-height: 1.6;\n\n    li {\n      margin-bottom: 10px;\n    }\n  }\n}\n\n.usageSteps {\n  .step {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    gap: 15px;\n\n    .stepNumber {\n      width: 30px;\n      height: 30px;\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 700;\n      font-size: 1.1rem;\n    }\n\n    p {\n      margin: 0;\n      color: #495057;\n    }\n  }\n}\n\n// Footer\n.tokenFooter {\n  text-align: center;\n  padding: 30px;\n  background: #f8f9fa;\n  border-radius: 15px;\n  margin-top: 40px;\n\n  p {\n    color: #6c757d;\n    margin: 5px 0;\n  }\n}\n\n// Loading and Error States\n.loading {\n  text-align: center;\n  padding: 50px;\n  font-size: 1.2rem;\n  color: #6c757d;\n}\n\n.noData {\n  text-align: center;\n  padding: 50px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .tokenMainContainer {\n    padding: 15px;\n  }\n\n  .tokenHeader h1 {\n    font-size: 2rem;\n  }\n\n  .tabNavigation {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .tabButton {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .formRow {\n    grid-template-columns: 1fr;\n  }\n\n  .actionButtons {\n    flex-direction: column;\n  }\n\n  .actionButton {\n    min-width: auto;\n  }\n\n  .statsGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .insightsGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .exportButtons {\n    flex-direction: column;\n  }\n\n  .infoSection {\n    grid-template-columns: 1fr;\n  }\n}\n\n// Modal Styles for Token Search\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modalContent {\n  background: white;\n  border-radius: 15px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 25px 30px;\n  border-bottom: 2px solid #e9ecef;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 15px 15px 0 0;\n\n  h3 {\n    margin: 0;\n    font-size: 1.5rem;\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.2);\n    transform: scale(1.1);\n  }\n}\n\n.modalBody {\n  padding: 30px;\n\n  .dataInfo, .accessInfo {\n    margin-bottom: 25px;\n\n    h4 {\n      color: #2c3e50;\n      margin-bottom: 15px;\n      font-size: 1.2rem;\n      border-bottom: 2px solid #e9ecef;\n      padding-bottom: 8px;\n    }\n  }\n\n  .infoGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 15px;\n  }\n\n  .infoItem {\n    background: #f8f9fa;\n    padding: 15px;\n    border-radius: 8px;\n    border-left: 4px solid #007bff;\n\n    strong {\n      color: #2c3e50;\n      display: block;\n      margin-bottom: 5px;\n    }\n  }\n\n  .accessDetails {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n    align-items: center;\n  }\n\n  .editNote, .viewNote {\n    background: #e8f5e8;\n    border: 1px solid #28a745;\n    border-radius: 8px;\n    padding: 15px;\n    margin-top: 20px;\n\n    p {\n      margin: 0;\n      color: #155724;\n      font-weight: 500;\n    }\n  }\n\n  .viewNote {\n    background: #fff3cd;\n    border-color: #ffc107;\n\n    p {\n      color: #856404;\n    }\n  }\n}\n\n.modalFooter {\n  padding: 20px 30px;\n  border-top: 2px solid #e9ecef;\n  text-align: center;\n  background: #f8f9fa;\n  border-radius: 0 0 15px 15px;\n}\n\n.closeModalButton {\n  padding: 12px 30px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background: #5a6268;\n    transform: translateY(-2px);\n  }\n}\n\n// Responsive Modal\n@media (max-width: 768px) {\n  .modalContent {\n    margin: 10px;\n    max-height: 95vh;\n  }\n\n  .modalHeader {\n    padding: 20px;\n    \n    h3 {\n      font-size: 1.3rem;\n    }\n  }\n\n  .modalBody {\n    padding: 20px;\n  }\n\n  .infoGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .accessDetails {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n// Token Search Page Styles\n.tokenSearchPageContainer {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 20px;\n  font-family: 'Arial', sans-serif;\n}\n\n.pageHeader {\n  text-align: center;\n  margin-bottom: 40px;\n  padding: 40px 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 20px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  position: relative;\n\n  h1 {\n    font-size: 3rem;\n    margin: 20px 0 15px 0;\n    font-weight: 700;\n  }\n\n  p {\n    font-size: 1.3rem;\n    opacity: 0.9;\n    margin: 0;\n  }\n}\n\n.backButton {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 25px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.tokenInput {\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.budgetPopupOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 1200;\n}\n\n.budgetPopupContainer {\n  width: min(1180px, 100%);\n  max-height: calc(100vh - 40px);\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.28);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.budgetPopupHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 22px;\n  border-bottom: 1px solid #e9ecef;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #ffffff;\n\n  h3 {\n    margin: 0;\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n}\n\n.budgetPopupClose {\n  border: none;\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  font-size: 1.3rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n}\n\n.budgetPopupMeta {\n  padding: 14px 22px;\n  background: #f8f9fb;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 24px;\n  font-size: 0.95rem;\n  color: #2c3e50;\n}\n\n.budgetPopupLoading {\n  padding: 28px 22px;\n  text-align: center;\n  color: #495057;\n  font-weight: 600;\n}\n\n.budgetPopupTableWrapper {\n  overflow: auto;\n  padding: 0 22px 12px;\n}\n\n.budgetPopupTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 780px;\n\n  th, td {\n    border-bottom: 1px solid #edf1f5;\n    padding: 10px 8px;\n    text-align: left;\n    vertical-align: middle;\n  }\n\n  th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: #f3f6fb;\n    color: #334155;\n    font-size: 0.92rem;\n    font-weight: 700;\n  }\n\n  td {\n    background: #ffffff;\n  }\n\n  input {\n    width: 100%;\n    border: 1px solid #d9dee7;\n    border-radius: 8px;\n    padding: 9px 10px;\n    font-size: 0.95rem;\n    color: #1f2937;\n    background: #ffffff;\n\n    &:focus {\n      outline: none;\n      border-color: #667eea;\n      box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);\n    }\n\n    &[readonly] {\n      background: #f5f7fb;\n      color: #5b6472;\n    }\n  }\n}\n\n.budgetPopupCategoryRow td {\n  background: #f3f6fb !important;\n  color: #1f2937;\n  font-weight: 700;\n  border-top: 1px solid #d8e2f0;\n  border-bottom: 1px solid #d8e2f0;\n}\n\n.budgetPopupTotalRow td {\n  background: #faf7ef !important;\n  font-weight: 700;\n  color: #5b4016;\n}\n\n.budgetPopupGrandTotalRow td {\n  background: #e7f6ec !important;\n  font-weight: 700;\n  color: #14532d;\n  border-top: 1px solid #cfe9d8;\n}\n\n.budgetPopupMessage {\n  margin: 10px 22px 0;\n  padding: 11px 14px;\n  border-radius: 10px;\n  font-size: 0.92rem;\n  font-weight: 600;\n\n  &.success {\n    background: #eafaf1;\n    color: #166534;\n    border: 1px solid #ccefdc;\n  }\n\n  &.error {\n    background: #fff1f2;\n    color: #9f1239;\n    border: 1px solid #ffd6de;\n  }\n}\n\n.budgetPopupActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 22px 18px;\n  border-top: 1px solid #e9ecef;\n  background: #ffffff;\n}\n\n.budgetPopupCancelButton,\n.budgetPopupSaveButton {\n  border: none;\n  border-radius: 10px;\n  padding: 10px 18px;\n  font-size: 0.94rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.budgetPopupCancelButton {\n  background: #e9ecef;\n  color: #334155;\n\n  &:hover {\n    background: #dfe3e8;\n  }\n}\n\n.budgetPopupSaveButton {\n  background: #e67e22;\n  color: #ffffff;\n\n  &:hover:not(:disabled) {\n    background: #d96f0f;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n@media (max-width: 900px) {\n  .budgetPopupOverlay {\n    padding: 10px;\n  }\n\n  .budgetPopupContainer {\n    max-height: calc(100vh - 20px);\n    border-radius: 12px;\n  }\n\n  .budgetPopupHeader {\n    padding: 14px 16px;\n\n    h3 {\n      font-size: 1rem;\n    }\n  }\n\n  .budgetPopupMeta {\n    padding: 12px 16px;\n    font-size: 0.88rem;\n  }\n\n  .budgetPopupTableWrapper {\n    padding: 0 10px 8px;\n  }\n\n  .budgetPopupTable {\n    min-width: 660px;\n  }\n\n  .budgetPopupActions {\n    padding: 12px 16px 14px;\n    flex-direction: column-reverse;\n  }\n\n  .budgetPopupCancelButton,\n  .budgetPopupSaveButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tokenMainContainer": `token_tokenMainContainer__Idw1B`,
	"tokenHeader": `token_tokenHeader__TSp6v`,
	"tabNavigation": `token_tabNavigation__IfgVk`,
	"tabButton": `token_tabButton__uTEzQ`,
	"activeTab": `token_activeTab__n5LLP`,
	"tabContent": `token_tabContent__n1ACj`,
	"tokenSearchContainer": `token_tokenSearchContainer__xZO0n`,
	"searchHeader": `token_searchHeader__nerS+`,
	"searchForm": `token_searchForm__mYP7v`,
	"inputGroup": `token_inputGroup__LaTic`,
	"searchButton": `token_searchButton__IYqkn`,
	"errorMessage": `token_errorMessage__6yjnh`,
	"searchResult": `token_searchResult__gWHkc`,
	"resultHeader": `token_resultHeader__NpmoD`,
	"accessInfo": `token_accessInfo__gNyA0`,
	"accessBadge": `token_accessBadge__rrFTW`,
	"view": `token_view__SbBKn`,
	"edit": `token_edit__4ggt6`,
	"admin": `token_admin__2FeVQ`,
	"expiryInfo": `token_expiryInfo__baGV4`,
	"dataPreview": `token_dataPreview__A90CT`,
	"infoGrid": `token_infoGrid__5VPt2`,
	"infoItem": `token_infoItem__hwCXY`,
	"currentYearNotice": `token_currentYearNotice__taC3c`,
	"actionButtons": `token_actionButtons__ppj38`,
	"actionButton": `token_actionButton__C5PL5`,
	"viewButton": `token_viewButton__NpssZ`,
	"editButton": `token_editButton__dNWJE`,
	"helpSection": `token_helpSection__K-E9S`,
	"tokenManagementContainer": `token_tokenManagementContainer__4-nx4`,
	"managementHeader": `token_managementHeader__J0twp`,
	"createButton": `token_createButton__Rm3bh`,
	"createForm": `token_createForm__+J3Zz`,
	"formRow": `token_formRow__zdt5V`,
	"formGroup": `token_formGroup__pHPZ9`,
	"formActions": `token_formActions__4meBf`,
	"submitButton": `token_submitButton__F-vfX`,
	"cancelButton": `token_cancelButton__zC+OM`,
	"tokenAccessList": `token_tokenAccessList__vgOCg`,
	"tableContainer": `token_tableContainer__tyFlx`,
	"tokenTable": `token_tokenTable__jGS9i`,
	"expired": `token_expired__8Aqxl`,
	"tokenCell": `token_tokenCell__39-w-`,
	"statusBadge": `token_statusBadge__7m7mK`,
	"active": `token_active__3iSY1`,
	"inactive": `token_inactive__fSTOA`,
	"actionCells": `token_actionCells__J8giR`,
	"deleteButton": `token_deleteButton__jwB5t`,
	"editModal": `token_editModal__wfn+p`,
	"modalContent": `token_modalContent__yklVQ`,
	"analyticsContainer": `token_analyticsContainer__cx6PL`,
	"analyticsHeader": `token_analyticsHeader__Hom7F`,
	"statsGrid": `token_statsGrid__wrDwG`,
	"statCard": `token_statCard__5z7bB`,
	"statIcon": `token_statIcon__Vd0tP`,
	"statContent": `token_statContent__iGQgE`,
	"statNumber": `token_statNumber__q5DgY`,
	"chartSection": `token_chartSection__a4Eq+`,
	"progressBar": `token_progressBar__LtUin`,
	"progressFill": `token_progressFill__qiywN`,
	"chartLabels": `token_chartLabels__19bpq`,
	"recentSearches": `token_recentSearches__BFkuu`,
	"analyticsTable": `token_analyticsTable__6T5hj`,
	"found": `token_found__w79rL`,
	"not_found": `token_not_found__CYT9p`,
	"no_access": `token_no_access__U4Xo8`,
	"resultBadge": `token_resultBadge__2DrJc`,
	"insightsSection": `token_insightsSection__0lojb`,
	"insightsGrid": `token_insightsGrid__WQkt-`,
	"insightCard": `token_insightCard__QfPV7`,
	"exportSection": `token_exportSection__sYxgI`,
	"exportButtons": `token_exportButtons__N8e5J`,
	"exportButton": `token_exportButton__Hrn7G`,
	"infoSection": `token_infoSection__IAMjq`,
	"infoCard": `token_infoCard__sxJIp`,
	"usageSteps": `token_usageSteps__CB8Ca`,
	"step": `token_step__07dx2`,
	"stepNumber": `token_stepNumber__pUcE2`,
	"tokenFooter": `token_tokenFooter__zQ+B2`,
	"loading": `token_loading__R8Tb4`,
	"noData": `token_noData__t74KF`,
	"modalOverlay": `token_modalOverlay__RzF7W`,
	"modalSlideIn": `token_modalSlideIn__CujcO`,
	"modalHeader": `token_modalHeader__b3xTv`,
	"closeButton": `token_closeButton__ufaXm`,
	"modalBody": `token_modalBody__ahVHr`,
	"dataInfo": `token_dataInfo__RlXZP`,
	"accessDetails": `token_accessDetails__NcltG`,
	"editNote": `token_editNote__YlCvj`,
	"viewNote": `token_viewNote__YqSLH`,
	"modalFooter": `token_modalFooter__1rSqO`,
	"closeModalButton": `token_closeModalButton__HCNl3`,
	"tokenSearchPageContainer": `token_tokenSearchPageContainer__cehDj`,
	"pageHeader": `token_pageHeader__YOejx`,
	"backButton": `token_backButton__rL27o`,
	"tokenInput": `token_tokenInput__FxqMt`,
	"budgetPopupOverlay": `token_budgetPopupOverlay__Ghq6p`,
	"budgetPopupContainer": `token_budgetPopupContainer__U1cNb`,
	"budgetPopupHeader": `token_budgetPopupHeader__eY0rd`,
	"budgetPopupClose": `token_budgetPopupClose__loz9t`,
	"budgetPopupMeta": `token_budgetPopupMeta__bi7Sy`,
	"budgetPopupLoading": `token_budgetPopupLoading__JENJB`,
	"budgetPopupTableWrapper": `token_budgetPopupTableWrapper__QRH3k`,
	"budgetPopupTable": `token_budgetPopupTable__mp64l`,
	"budgetPopupCategoryRow": `token_budgetPopupCategoryRow__+nXPc`,
	"budgetPopupTotalRow": `token_budgetPopupTotalRow__0mooG`,
	"budgetPopupGrandTotalRow": `token_budgetPopupGrandTotalRow__oPVF+`,
	"budgetPopupMessage": `token_budgetPopupMessage__YCC+Q`,
	"success": `token_success__xcb0L`,
	"error": `token_error__XrA6r`,
	"budgetPopupActions": `token_budgetPopupActions__K8b2p`,
	"budgetPopupCancelButton": `token_budgetPopupCancelButton__etVhI`,
	"budgetPopupSaveButton": `token_budgetPopupSaveButton__V+HWv`
};
export default ___CSS_LOADER_EXPORT___;
